import React, {useEffect, useState} from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { docLinkFormatter, formatDateTime } from "../helpers/helperFunctions";
import { Col, Container, Row } from "react-bootstrap";

const PopUpComponent = ({visible, data, onCollapse})=>{

    const [show, setShow] = useState(false);

    const handleClose = () => onCollapse();
   

    useEffect(()=>{
setShow(visible)

    },[visible])
  
    return (
      <>
     
  
        <Modal show={show} onHide={handleClose} size="lg" >
          <Modal.Header closeButton>
            
            <Modal.Title><div className="dist-title">District</div>{data['District']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
                <Row>
                    <Col>
                    <table className="pop-table">
                <tr>
                    <td>Member Name(s)</td>
                    <td>: {data['Member Name(s)']}</td>
                </tr>
                <tr>
                    <td>Notes</td>
                    <td>: {data['Notes']}</td>
                </tr>
                <tr>
                    <td>Date Time</td>
                    <td>: {formatDateTime(data['Date Time'])}</td>
                </tr>
                <tr>
                    <td>Representative/Senator</td>
                    <td>: {data['Representative/Senator']}</td>
                </tr>
                <tr>
                    <td>Office Location</td>
                    <td>: {data['Office Location']}</td>
                </tr>
                <tr>
                    <td>Talking Points Documents</td>
                    <td>: { docLinkFormatter(data['Talking Points Documents'])}</td>
                </tr>
            </table>
                    </Col>
                </Row>
         
            </Container>
           

          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="secondary" onClick={handleClose}>
              Close
            </Button> */}
           
          </Modal.Footer>
        </Modal>
      </>
    );

   
}
export default PopUpComponent